<template>
  <div class="wrapper">

    <el-form
        :model="staffData"
        class="demo-form-inline"
        label-width="120px"
        ref="formRef"
        :rules="staffRules"
    >
      <div class="title">基本信息</div>
      <el-form-item label="员工姓名" prop="userName">
        <el-input
            v-model="staffData.userName"
            placeholder="请输入员工姓名"
            style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属部门" prop="groupId">
        <div
            class="chooseContainer"
        >
        <tree-select
            :groupTree="departmentGroupTree"
            :groupChosenIds="staffData.deptId"
            :showCheckbox="true"
            :checkStrictly="true"
            @eventUp="studentGroupEvent"
            :check-on-click-node="true"
            ref="studentGroupSelectTree"
        ></tree-select>
        </div>
      </el-form-item>
      <el-form-item label="员工性别" prop="sex">
        <el-radio v-model="staffData.sex" :label="0">保密</el-radio>
        <el-radio v-model="staffData.sex" :label="1">男</el-radio>
        <el-radio v-model="staffData.sex" :label="2">女</el-radio>
      </el-form-item>
      <el-form-item label="手机号码" prop="mobile">
        <el-input
            style="width: 300px"
            v-model="staffData.mobile"
            placeholder="请输入手机号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idCard">
        <el-input
            style="width: 300px"
            v-model="staffData.idCard"
            placeholder="请输入身份证号"
        ></el-input>
      </el-form-item>
      <div class="title">更多信息</div>
      <el-form-item label="籍贯" prop="hometown">
        <el-input
            style="width: 300px"
            v-model="staffData.hometown"
            placeholder="请输入籍贯"
        ></el-input>
      </el-form-item>
      <el-form-item label="学历" prop="education">
        <el-input
            style="width: 300px"
            v-model="staffData.education"
            placeholder="请输入学历"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="staffData.ifShow = false">取 消</el-button>
      <el-button type="primary" @click="submitData">保存</el-button>
    </span>

  </div>
</template>

<script>
import { saveSystemUser, updateSystemUser, getRoleListNew,searchDepartmentGroup,addStaffUser } from "@/api/index";
import mytree from "@/views/component/mytree.vue";
import treeSelect from "@/component/tree/treeSelect.vue";

export default {
  components: {
    mytree,
    treeSelect,
  },
  data() {
    return {
      departmentGroupTree:[],
      roleList: [],
      staffRules: {
        userName: [
          { required: true, message: "请输入员工姓名", trigger: "change" },
        ],
        deptId: [
          { required: true, message: "请选择所属部门", trigger: "change" },
        ],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    staffData: {
      handler() {},
      deep: true,
    },
  },
  props: {
    staffData: {
      type: Object,
      default: () => ({
        idCard:"",
        ifShow: false,
        userName: "",
        account: "",
        sourcePassword: "",
        deptId: [],
        roleId: "",
        sex: 0,
        birthdayDate: null,
        emailAddress: "",
        mobile: "",
        weChatAccount: "",
        landline: "",
        jobNumber: "",
        hometown: "",
        graduatedSchool: "",
        graduatedDate: null,
        education: "",
        major: "",
        remark: "",
        id: 0,

      }),
    },
  },
  created() {},
  mounted() {
    getRoleListNew({
      pageNumber: 1,
      pageSize: 1000,
    }).then((data) => {
      this.roleList = data.rows;
    });
    this.getDepartmentGroup();
  },
  methods: {
    close(){

    },
    getDepartmentGroup() {
      searchDepartmentGroup().then((data) => {
        data.unshift({
          groupName: "所有组织架构",
          id: 0,
          parentId: 0,
          children: [],
        });
        this.departmentGroupTree = data;
        console.log("组织架构:" ,this.departmentGroupTree);
      });
    },

    studentGroupEvent(eventDetail, treeData) {
      console.log("treeData",treeData);
      switch (eventDetail.type) {
        case "chosenKeysConfirm":
          console.log("chosenKeysConfirm",eventDetail);
          this.staffData.deptId = eventDetail.chosenKeys;
          break;
        case "chosen":
          console.log("chosen",eventDetail);
          this.studentGroupChosen = eventDetail.value;
          break;
        case "select":
          console.log("select",eventDetail);
          this.temporaryTree = eventDetail.value;
          break;
        case "confirm":
          console.log("confirm",eventDetail);
          // this.examinationType = this.temporaryTree;
          this.staffData.deptId= this.temporaryTree.id;
          break;
        default:
          break;
      }

    },
    submitData() {
      console.log("提交的用户数据",this.staffData);
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let postData = {},
              that = this;
          for (let i in this.staffData) {
            if (this.staffData[i] || this.staffData[i] === 0) {
              postData[i] = this.staffData[i];

            }
          }
          // if (this.staffData.id!=0) {
          //   addStaffUser(postData).then(
          //       (data) => {
          //         that.$emit("eventUp", { type: "success", value: data });
          //       },
          //       (err) => {
          //         console.log(err);
          //       }
          //   );
          // } else {
            addStaffUser(postData).then(
              (data) => {
                that.$emit("eventUp", {type: "success", value: "保存成功"});
              },
                  (err) => {
                    console.log(err);
                  }

            );


        } else {
          this.$alert("请检查必填项");
          //   console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  padding: 0 15%;
  .title {
    font-weight: bold;
    font-size: 20px;
    line-height: 32px;
    position: relative;
    margin-bottom: 10px;
    &::after {
      content: "";
      position: absolute;
      width: 6px;
      height: 32px;
      top: 0;
      left: -10px;
      background: #618afd;
      border-radius: 2px;
    }
    .chooseContainer {
      .showBar {
        padding: 10px;
        border: 1px solid #36aafd;
        border-radius: 5px;
        width: 80%;
        .el-button--small,
        .el-tag {
          margin-right: 10px;
        }
        min-height: 50px;
      }
    }
  }

}
</style>
